"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muteUnhandledRejectionError = void 0;
function setErrorMute(error) {
    if (error) {
        error.mute = true;
    }
}
if (typeof window !== 'undefined') {
    window.addEventListener('unhandledrejection', errorEvent => {
        var _a;
        if ((_a = errorEvent.reason) === null || _a === void 0 ? void 0 : _a.mute) {
            errorEvent.preventDefault();
            if (process.env.NODE_ENV === 'development' && __react_refresh_error_overlay__) { // eslint-disable-line 
                setTimeout(() => {
                    __react_refresh_error_overlay__ === null || __react_refresh_error_overlay__ === void 0 ? void 0 : __react_refresh_error_overlay__.clearRuntimeErrors();
                }, 30);
            }
        }
    });
}
exports.muteUnhandledRejectionError = async (ctx, next) => {
    await next();
    const { error, request } = ctx;
    if (error && request.muteUnhandledRejectionError) {
        const { shouldErrorBeMute } = request.muteUnhandledRejectionError;
        if (shouldErrorBeMute(error)) {
            setErrorMute(error);
        }
    }
};
//# sourceMappingURL=muteUnhandledRejectionError.js.map